import gql from "graphql-tag"
import {AllBudgetCategoriesFragment} from "./budgetCategories"

export const WalletFragment = gql`
  fragment WalletFragment on Wallet {
    amount
    availableBalance
    availableBalanceInCents
    currency
    ownerUuid
    uuid
  }
`

export const FullWalletFragment = gql`
  fragment FullWalletFragment on Wallet {
    ...WalletFragment
    budgets {
      ...AllBudgetCategoriesFragment
    }
  }

  ${WalletFragment}
  ${AllBudgetCategoriesFragment}
`

export const NextTopup = gql`
  fragment NextTopup on Wallet {
    nextTopup {
      amount
      date
    }
  }
`
